import React, { Component } from 'react';
import { appImgAlt, domainUrl, routeAfterLogin } from '../config/Config';
import { UserId } from '../helpers/User';
import * as Common from '../helpers/Common';

// Assign $ & window value to use jquery
const $ = window.$;
const win = window;

export default class Feathers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            appImgAlt: appImgAlt,
            featherList: []
        };
    }
    getfeatherList() {
        Common.reactLoader("show", "Please wait...");
        fetch(domainUrl + "get/observer/feathers", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Common.getTokenData()
            },
            body: JSON.stringify({
                user_id: UserId()
            })
        }).then((response) => response.json()).then((responseJson) => {
            Common.reactLoader("hide");
            if (responseJson.status !== 0) {
                this.setState({
                    featherList: responseJson.feathers
                })
            }
        });
    }
    navigateUser(length) {
        let nextItem = length + 1;
        if (this.state.featherList.length !== nextItem) {
            $(".feather-block" + length).fadeOut("fast");
            $(".feather-block" + nextItem).fadeIn("fast");
        } else {
            // Clear the snow fall animation
            win.snowFall.snow(document.body, "clear");
            Common.reactLoader("show", "Please wait...");
            fetch(domainUrl + "update/observer/feathers", {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + Common.getTokenData()
                },
                body: JSON.stringify({
                    user_id: UserId()
                })
            }).then((response) => response.json()).then((responseJson) => {
                if (responseJson.status !== 0) {
                    let userData = Common.parseJwt(Common.getTokenData());
                    if (userData.afterRoutes.length > 1) {
                        userData.afterRoutes.splice(0, 1);
                        Common.setUserData("afterRoutes", userData.afterRoutes, true);
                        setTimeout(() => {
                            Common.reactLoader("hide");
                            this.props.router.push(userData.afterRoutes[0].url);
                        }, 1200);
                    } else {
                        Common.setUserData("globalAccess", true, true);
                        setTimeout(() => {
                            Common.setUserData("afterRoutes", [], true);
                        }, 500);
                        setTimeout(() => {
                            Common.reactLoader("hide");
                            this.props.router.push(routeAfterLogin);
                        }, 1200);
                    }
                }
            });
        }
    }
    componentWillMount() {
        this.getfeatherList();
    }
    componentDidMount() {
        document.body.className = "events-wrapper";
        win.snowFall.snow(document.body, {
            image: "images/flake3.png",
            minSize: 10,
            maxSize: 30
        });
        win.snowFall.snow(document.body, {
            image: "images/flake2.png",
            minSize: 10,
            maxSize: 30
        });
        win.snowFall.snow(document.body, {
            image: "images/flake1.png",
            minSize: 10,
            maxSize: 30
        });
    }
    render() {
        const featherHtml = this.state.featherList.map((val, key) => {
            let attribute = (key === 0) ? { display: "block" } : { display: "none" };
            return <div key={`level1_div_${key}`} className={`feather-block${key}`} style={attribute}>
                <div className="feather-div">
                    <h1>You got New Feather from</h1>
                    <div className="feather-name">{val.name}</div>
                    <div className="feather-no">No of new feathers :<span>{val.count}</span></div>
                </div>
                <div className="bt-div">
                    <a href="javascript:void(0);" onClick={() => this.navigateUser(key)} className="cnt-btn">Continue</a>
                </div>
            </div>
        });
        return (<div className="darkBg">
            <div className="user-top">
                <div className="row">
                    <div className="logo">
                        <img src={process.env.PUBLIC_URL + '/images/logo-361dm.png'} alt="" title={this.state.appImgAlt} />
                    </div>
                </div>
            </div>
            <div className="container balloon-con cong-con">
                <div className="congrats-img">
                    <img src={process.env.PUBLIC_URL + '/images/congrats.png'} alt="" title="" />
                </div>
                {featherHtml}
            </div>
            <img src={process.env.PUBLIC_URL + '/images/g-baloon1.png'} alt="" title="" className="g-baloon1" />
            <img src={process.env.PUBLIC_URL + '/images/g-baloon.png'} alt="" title="" className="g-baloon2" />
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/pages/Feathers.js